{
  "legalConfirmLabel": "Fechar",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "Política de privacidade",
  "legalTermsOfUse": "Termos de uso",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_br",
  "profileLegalNoticesMenuItem": "Avisos legais"
}
